import { BookOpenText } from '@phosphor-icons/react'

import { Order } from '@consumer/graphql'
import { InstructionsRender } from '../../Instructions/Common/InstructionsRender'
import AddEditBox from '../Common/AddEditBox'

interface DeliveryInstructionsProps {
  order: Order
  canEdit: boolean
  onEdit?: () => void
}

/** Displays the delivery instructions for an order's address with an optional edit action. */
export default function DeliveryInstructions({ order, canEdit, onEdit }: DeliveryInstructionsProps) {
  return (
    <AddEditBox label="delivery instructions" ContentIcon={BookOpenText} canEdit={canEdit} onEdit={onEdit}>
      <InstructionsRender order={order} />
    </AddEditBox>
  )
}
